<template>
  <div class="p-fluid p-my-3">
    
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="oppDescription">Description</label>
        <InputText
          class="clearer"
          id="oppDescription"
          v-model.trim="opportunity1.oppDescription"
          required="false"
          :disabled="true"
          autofocus
        />
      </div>
      <div
        v-if="opportunity1.quoteNo || opportunity1.quoteNo === null"
        class="p-field p-col-6"
      >
        <label for="branch">Quote No</label>
        <InputText
          class="clearer"
          v-model="opportunity1.quoteNo"
          optionLabel="branchName"
          placeholder="Select Branch"
          :disabled="true"
          autofocus
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="address1">House</label>
        <InputText
          class="clearer"
          id="address1"
          v-model.trim="opportunity1.address1"
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="address2">Street</label>
        <InputText
          class="clearer"
          id="address2"
          v-model.trim="opportunity1.address2"
          required="false"
          :disabled="true"
          autofocus
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="address3">Sub Area</label>
        <InputText
          class="clearer"
          id="address3"
          v-model.trim="opportunity1.address3"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="address4">City/Town</label>
        <!-- <InputText
          class="clearer"
          id="address4"
          v-model.trim="opportunity1.address4"
          required="false"
          :disabled="true"
          autofocus
        /> -->
        <div v-if="opportunity1.cityTown">
          <InputText
            class="clearer"
            id="cityTown"
            v-model="opportunity1.cityTown.cityTownName"
            required="false"
            :disabled="true"
            autofocus
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="postCode">Post Code</label>
        <InputText
          class="clearer"
          id="postCode"
          v-model.trim="opportunity1.postCode"
          required="false"
          :disabled="true"
          autofocus
        />
      </div>
      <div class="p-field p-col">
        <label for="region">Region</label>
        <div v-if="opportunity1.region">
          <InputText
            class="clearer"
            id="region"
            v-model="opportunity1.region.regionName"
            required="false"
            :disabled="true"
            autofocus
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
        <!-- <label for="country">Country</label>
        <InputText
          id="country"
          v-model.trim="opportunity1.country"
          required="false"
          :disabled="true"
          autofocus
        /> -->
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="customer">Customer *</label>
        <InputText
          class="clearer"
          id="customer"
          v-model.trim="customerName"
          required="false"
          :disabled="true"
          autofocus
        />
      </div>
      <div class="p-field p-col" style="position: relative">
        <label for="contact">Contact *</label>
        <div v-if="opportunity1.contact">
          <InputText
            class="clearer"
            id="contact"
            v-model="opportunity1.contact.contactName"
            required="false"
            :disabled="true"
            autofocus
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col p-sm-6">
        <label for="projectType">Enquiry Type *</label>
        <div v-if="opportunity1.projectType">
          <InputText
            class="clearer"
            id="projectType"
            v-model="opportunity1.projectType.projTypeName"
            required="false"
            :disabled="true"
            autofocus
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-field p-col p-sm-6">
        <label for="opportunityStatus">Branch</label>
        <div v-if="opportunity1.mbpBranch">
          <InputText
            class="clearer"
            v-model="opportunity1.mbpBranch.branchName"
            optionLabel="branchName"
            placeholder="Select Branch"
            :disabled="true"
            autofocus
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col p-sm-6">
        <label for="phoneNo">Phone No</label>
        <InputText
          class="clearer"
          id="phoneNo"
          v-model.trim="opportunity1.phoneNo"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col p-sm-6">
        <label for="email">Email</label>
        <InputText
          class="clearer"
          id="email"
          v-model.trim="opportunity1.email"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="salesExec">Sales Exec</label>
        <div v-if="opportunity1.salesExec">
          <InputText
            class="clearer"
            id="salesExec"
            v-model="opportunity1.salesExec.salesExecName"
            required="false"
            autofocus
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
      <div class="p-field p-col">
        <label for="custRef">Product Type</label>
        <InputText
          class="clearer"
          id="productType"
          v-model="opportunity1.quoteProdType"
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="custRef">Quote Value</label>
        <br />
        <div style="width: 100%; height: 37px; border: 1px solid rgb(0 0 0 / 9%);, border-radius: 3px; padding-top: 7px;">
          {{ getToShow(opportunity1.productValue) }}
        </div>
      </div>
      <div class="p-field p-col">
        <label for="custRef">Quote Qty</label>
        <InputText
          class="clearer"
          id="quoteQty"
          v-model.trim="opportunity1.quoteQty"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
     <div class="p-field p-col">
        <label for="chaseBy">Chase By</label>
        <div v-if="opportunity1.quoteChaseBy">
          <InputText
            class="clearer"
            id="chaseBy"
            v-model="opportunity1.quoteChaseBy"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
     <div class="p-field p-col">
        <label for="salesExec">Sales Executive</label>
        <div v-if="opportunity1.salesExec && opportunity1.salesExec.salesExecName">
          <InputText
            class="clearer"
            id="salesExec"
            v-model="opportunity1.salesExec.salesExecName"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="dateReceived">Date Received</label>
        <InputText
          class="clearer"
          id="dateReceived"
          v-model.trim="opportunity1.dateReceived"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="requestedBy">Requested By</label>
        <InputText
          class="clearer"
          id="requestedBy"
          v-model.trim="opportunity1.requestedBy"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="ABI">ABI No</label>
        <InputText
          class="clearer"
          id="abiNo"
          v-model.trim="opportunity1.abiNo"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="custRef">Customer Ref</label>
        <InputText
          class="clearer"
          id="custRef"
          v-model.trim="opportunity1.custRef"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="custRef">Status Comment</label>
        <InputText
          class="clearer"
          id="statusComment"
          v-model.trim="opportunity1.statusComment"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
      <div class="p-field p-col">
        <label for="manufacturer">Manufacturer</label>
        <div v-if="opportunity1.wonManufacturer">
            <InputText
              class="clearer"
              id="manufacturer"
              v-model="opportunity1.wonManufacturer.manufacturerName"
              :disabled="true"
            />
          </div>
          <div v-else>
            <InputText
              placeholder=""
              :disabled="true"
            />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="custRef">Lost Reason</label>
        <div v-if="opportunity1.lostQuoteReason">
          <InputText
            class="clearer"
            id="lostQuoteReason"
            v-model="opportunity1.lostQuoteReason.lqNoteDesc"
            :disabled="true"
          />
        </div>
        <div v-else>
          <InputText
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
    </div>
    <div class="p-formgrid p-grid">
      <div class="p-field p-col">
        <label for="notes">Notes</label>
        <InputText
          class="clearer"
          id="notes"
          v-model.trim="opportunity1.notes"
          required="false"
          autofocus
          :disabled="true"
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="createdBy">Created By:</label>
        <InputText
          v-if="opportunity1.createdBy"
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="opportunity1.createdBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="created">Date Created:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="opportunity1.dateCreated"
        ></InputText>
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-6 p-md-6">
        <label for="updatedBy">Updated By:</label>
        <InputText
          v-if="opportunity1.updatedBy"
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="opportunity1.updatedBy.fullName"
        ></InputText>
        <InputText
          v-else
          type="text"
          placeholder=""
          :disabled="true"
        ></InputText>
      </div>
      <div class="p-field p-col-6 p-md-6">
        <label for="updated">Date Updated:</label>
        <InputText
          class="clearer"
          type="text"
          placeholder=""
          :disabled="true"
          v-model="opportunity1.dateUpdated"
        ></InputText>
      </div>
    </div>
  </div>
</template>

<script>
import { formatCurrency } from '@/utils/money';
import OpportunityService from "@/service/OpportunityService";
import CustomerService from "@/service/CustomerService";

export default {
  props: ["opportunity"],
  data() {
    return {
      opportunityService: new OpportunityService(),
      customerService: new CustomerService(),
      opportunity1: null,
      customerName: '',
    };
  },
  created() {
    this.onCreated()
  },
  watch: {
    opportunity1(val) {
      
      if (val.customer)
        this.customerName = val.customer.custName
    },
    opportunity(val) {
      this.onCreated()
    },
  },
  methods: {
    onCreated() {
      if (!this.opportunity && this.$route.params.custid) {
      this.opportunityService
        .getOpportunityInfo(this.$route.params.custid)
        .then(data => {
          this.opportunity1 = data
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while getting enquiry info",
            life: 5000,
          })
        })
      } else if (this.opportunity) {
        this.opportunity1 = this.opportunity
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data) {
      if (data) {
        return formatCurrency(data)
      }
    }
  }
};
</script>